'use strict';

module.exports = require('./Table');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-table/lib/index.js
 ** module id = 632
 ** module chunks = 0
 **/